
export default class DtoApplicationSettings {
    constructor(obj) {
        this.module = obj.module // String,
        this.parameter = obj.parameter // String,
        this.value = obj.value // Option[String]
    }
}